module.exports = __webpack_public_path__ + "img/ic_h5_vip33.e73ac0b9.png";